'use es6';

import FilterOperatorErrorType from 'customer-data-filters/components/propTypes/FilterOperatorErrorType';
import I18n from 'I18n';
import UIFormControl from 'UIComponents/form/UIFormControl';
import { jsx as _jsx } from "react/jsx-runtime";
const FilterOperatorNoInputInput = ({
  error
}) => /*#__PURE__*/_jsx(UIFormControl, {
  "aria-label": I18n.text('customerDataFilters.FilterOperatorInput.ariaLabel'),
  error: error.get('error'),
  validationMessage: error.get('error') ? error.get('message') : null,
  children: /*#__PURE__*/_jsx("div", {})
});
FilterOperatorNoInputInput.propTypes = {
  error: FilterOperatorErrorType.isRequired
};
export default FilterOperatorNoInputInput;